import bundledContent from './aiTravelPlanner.generated.json';

function formatContent(value, limits) {
  if (typeof value === 'string') return Object.entries(limits).reduce((text, [key, replacement]) => text.split(`{${key}}`).join(String(replacement)), value);
  if (Array.isArray(value)) return value.map(item => formatContent(item, limits));
  if (value && typeof value === 'object') return Object.fromEntries(Object.entries(value).map(([key, item]) => [key, formatContent(item, limits)]));
  return value;
}
const fallbackContent = formatContent(bundledContent, bundledContent.previewLimits);

export function getAiTravelPlannerContent() {
  if (typeof document !== 'undefined') {
    try {
      const content = JSON.parse(document.getElementById('trackme-ai-planner-data')?.textContent || 'null');
      if (content?.path === bundledContent.path && content.form && content.example && content.conditions && Array.isArray(content.faq)) return content;
    } catch { /* Client navigation uses the generated copy. */ }
  }
  return fallbackContent;
}

export function getAiTravelPlannerJsonLd(content = getAiTravelPlannerContent()) {
  const url = `https://trackme.su${content.path}`;
  return [
    {
      '@context': 'https://schema.org', '@type': 'WebApplication', '@id': `${url}#application`,
      name: content.h1, description: content.description, url, inLanguage: 'ru-RU',
      applicationCategory: 'TravelApplication', operatingSystem: 'Any',
      browserRequirements: 'Для интерактивной генерации требуется JavaScript.',
      dateModified: content.dateModified, publisher: { '@type': 'Organization', name: 'TrackMe', url: 'https://trackme.su/' },
      featureList: ['Пробный план поездки по дням', 'Перенос пунктов в новое путешествие', 'Редактирование сохранённого путешествия'],
      screenshot: content.screenshots.items.map(item => item.src),
    },
    {
      '@context': 'https://schema.org', '@type': 'BreadcrumbList', '@id': `${url}#breadcrumbs`,
      itemListElement: [
        { name: 'Главная', path: '/' }, { name: 'Планирование путешествий', path: '/planirovanie-puteshestviy/' }, { name: content.h1, path: content.path },
      ].map((item, index) => ({ '@type': 'ListItem', position: index + 1, name: item.name, item: `https://trackme.su${item.path}` })),
    },
    {
      '@context': 'https://schema.org', '@type': 'FAQPage', '@id': `${url}#faq`,
      mainEntity: content.faq.map(item => ({ '@type': 'Question', name: item.question, acceptedAnswer: { '@type': 'Answer', text: item.answer } })),
    },
  ];
}

export const AI_PREVIEW_STORAGE_KEY = 'trackme_public_itinerary_preview';

export function isValidAiPreview(preview) {
  return Boolean(preview && preview.success !== false && typeof preview.preview_token === 'string' && preview.preview_token.trim()
    && typeof preview.destination === 'string' && Array.isArray(preview.days) && preview.days.length
    && preview.days.every(day => day && typeof day.title === 'string' && Array.isArray(day.items) && day.items.length && day.items.every(item => item && typeof item.title === 'string')));
}

export function readCachedAiPreview() {
  try {
    const preview = JSON.parse(sessionStorage.getItem(AI_PREVIEW_STORAGE_KEY) || 'null');
    return isValidAiPreview(preview) ? preview : null;
  } catch { return null; }
}
